import { render, staticRenderFns } from "./DashTutoringOld.vue?vue&type=template&id=421131e0"
import script from "./DashTutoringOld.vue?vue&type=script&lang=js"
export * from "./DashTutoringOld.vue?vue&type=script&lang=js"
import style0 from "./DashTutoringOld.vue?vue&type=style&index=0&id=421131e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports